import { h, card, apiClient, pill, btn, sectionHeader, openQuickTaskModal } from './_common.js';

export async function renderDescubrir(root) {
  root.innerHTML = '';
  const wrap = h('div', { class: 'animate-fade-in' });
  wrap.appendChild(sectionHeader('🔍', 'Descubrir', 'Hacker News · GitHub Trending · Product Hunt', [
    btn('✅ + Tarea', () => openQuickTaskModal('personal'), { variant: 'secondary' }),
    btn('⟳ Refrescar', () => renderDescubrir(root), { variant: 'secondary' }),
  ]));
  wrap.appendChild(h('div', { class: 'grid grid-cols-1 lg:grid-cols-3 gap-4' }, [
    h('div', { id: 'd-hn' }),
    h('div', { id: 'd-gh' }),
    h('div', { id: 'd-ph' }),
  ]));
  root.appendChild(wrap);

  const data = await apiClient.get('/api/v1/discover').catch(() => null);
  if (!data) {
    wrap.querySelector('#d-hn').innerHTML = '<p class="text-red-400">No se pudo cargar.</p>';
    return;
  }

  const hn = wrap.querySelector('#d-hn');
  hn.appendChild(card('🔶 Hacker News', { subtitle: 'Top stories' }));
  (data.hackerNews || []).slice(0, 12).forEach((s) => hn.appendChild(
    h('a', {
      href: s.url || `https://news.ycombinator.com/item?id=${s.id}`,
      target: '_blank',
      class: 'block bg-base-800/40 border border-base-700 hover:border-gold-400/40 rounded-lg p-3 mb-2 transition-colors',
    }, [
      h('div', { class: 'text-sm font-medium line-clamp-2' }, s.title),
      h('div', { class: 'flex gap-3 mt-1 text-xs text-ink-400' }, [
        h('span', {}, `▲ ${s.score}`),
        h('span', {}, `💬 ${s.descendants || 0}`),
        h('span', {}, `by ${s.by}`),
      ]),
    ]),
  ));

  const gh = wrap.querySelector('#d-gh');
  gh.appendChild(card('⭐ GitHub trending', { subtitle: 'Daily' }));
  if ((data.githubTrending || []).length === 0) {
    gh.appendChild(h('p', { class: 'text-sm text-ink-300' }, 'Sin datos (scrape puede haber fallado).'));
  }
  (data.githubTrending || []).slice(0, 12).forEach((r) => gh.appendChild(
    h('a', {
      href: r.url, target: '_blank',
      class: 'block bg-base-800/40 border border-base-700 hover:border-gold-400/40 rounded-lg p-3 mb-2 transition-colors',
    }, [
      h('div', { class: 'text-sm font-medium' }, r.name),
      r.description ? h('div', { class: 'text-xs text-ink-300 mt-1 line-clamp-2' }, r.description) : null,
      h('div', { class: 'flex gap-3 mt-2 text-xs text-ink-400' }, [
        h('span', { class: 'text-gold-300' }, `⭐ ${r.stars.toLocaleString('es-ES')}`),
        r.todayStars ? h('span', {}, `+${r.todayStars} hoy`) : null,
        r.language ? pill(r.language, 'gray') : null,
      ]),
    ]),
  ));

  const ph = wrap.querySelector('#d-ph');
  ph.appendChild(card('🚀 Product Hunt', { subtitle: 'Productos nuevos' }));
  if ((data.productHunt || []).length === 0) {
    ph.appendChild(h('p', { class: 'text-sm text-ink-300' }, 'Sin datos.'));
  }
  (data.productHunt || []).slice(0, 10).forEach((p) => ph.appendChild(
    h('a', {
      href: p.url, target: '_blank',
      class: 'block bg-base-800/40 border border-base-700 hover:border-gold-400/40 rounded-lg p-3 mb-2 transition-colors',
    }, [
      h('div', { class: 'text-sm font-medium' }, p.name),
      h('div', { class: 'text-xs text-ink-300 mt-1 line-clamp-2' }, p.tagline),
    ]),
  ));
}
